import React from "react";
import { configure } from "mobx";
import Notification from "./Notification";
import Locale from "./Locale";
import { INotificationStore } from "./Notification/Notification.types";
import { ILocaleStore } from "./Locale/Locale.types";
import Global from "./Global";

configure({ isolateGlobalState: true });

export interface IRootStore {
  globalModule: Global,
  notificationModule: INotificationStore,
}

class Store {
  globalModule: Global;
  notificationModule: INotificationStore;
  localeModule: ILocaleStore;

  constructor() {
    this.globalModule = new Global(this);
    this.notificationModule = new Notification(this);
    this.localeModule = new Locale();
  }
}

export const storeContext = React.createContext(new Store());
export const useStore = () => React.useContext(storeContext);
